export default function GetUrl() {

    return "https://currenmexico.com/digitalsms/" // Produccion el back esta en curren mexico

    //return "http://localhost:3007/digitalsms/" // desarollo
    
}




